var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconStarEmpty = React.memo(function (props) {
    var color = props.color, filledColor = props.filledColor, filledOut = props.filledOut, rest = __rest(props, ["color", "filledColor", "filledOut"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: filledColor !== null && filledColor !== void 0 ? filledColor : color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeOpacity: filledOut ? 1 : 0.7, strokeWidth: "1", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("path", { d: "M15,4.7l3.3,6.8l7.5,1.1l-5.4,5.3l1.3,7.5L15,21.8l-6.7,3.5l1.3-7.5l-5.4-5.3l7.5-1.1 L15,4.7z" }))));
});
export default IconStarEmpty;
//# sourceMappingURL=IconStarEmpty.js.map